export let sizeTinyHeader = "ijQHOe";
export let sizeSmallHeader = "NIDBhd";
export let sizeMediumHeader = "BSJWie";
export let sizeLargeHeader = "DFNSCc";
export let sizeVeryLargeHeader = "jmXtme";
export let sizeHugeHeader = "ppR$Vb";
export let sizeEnormousHeader = "mvTQab";
export default {sizeTinyHeader,sizeSmallHeader,sizeMediumHeader,sizeLargeHeader,sizeVeryLargeHeader,sizeHugeHeader,sizeEnormousHeader};